import { useLocale } from "@/hooks/useLocale";
import { Banner } from "@/ui/Banner";
import { DynamicText } from "@/ui/DynamicText";
import { DynamicHtml } from "@/ui/DynamicHtml";
import { Col, Row } from "react-bootstrap";

export const AwardsPageBannerSection = ({ className }) => {
  const locale = useLocale();

  return (
    <Banner
      className={className}
      title={<DynamicText path={`page.awards.banner.title.${locale}`} tag="h1" />}
      image={{ path: "page.awards.banner.image", src: "/assets/banners/default.webp" }}
    >
      <Row>
        <Col xs={12} md={6}>
          <DynamicHtml path={`page.awards.banner.text.${locale}`} />
        </Col>
      </Row>
    </Banner>
  );
};
